const steps = [
  {
    n: "01",
    title: "Discovery",
    body:
      "We spend a weekend on-site. We walk the property, meet the neighborhood, cook in the kitchen. The brand lives here before we design a single mark.",
  },
  {
    n: "02",
    title: "Positioning",
    body:
      "Name, narrative, guest archetype, price ladder. We define what the property means before we decide how it looks.",
  },
  {
    n: "03",
    title: "Craft",
    body:
      "Identity, interiors direction, photography, copy, and website — produced in one studio, on one file, without hand-offs.",
  },
  {
    n: "04",
    title: "Launch & Hold",
    body:
      "We launch the direct-booking site, seed press, and stay on retainer for the first 90 days to hold the brand steady as bookings arrive.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 md:py-32 lg:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-6 reveal">
            <p className="overline mb-6">The Method</p>
            <h2 className="font-serif-editorial text-4xl sm:text-5xl lg:text-6xl leading-[0.98] tracking-[-0.02em] text-[#1A1A1A] font-light">
              Slow work,
              <br />
              <span className="italic text-[#6B5C4D]">standing</span>
              <br />longer.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8 reveal flex md:justify-end">
            <p className="text-[#5C564D] text-lg leading-relaxed max-w-md">
              Four movements, one studio. Every project begins with a weekend
              in residence and ends only when the brand can hold itself
              upright without us in the room.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-16">
          {steps.map((s, i) => (
            <div
              key={s.n}
              data-testid={`process-step-${i}`}
              className="reveal border-t border-[#1A1A1A]/15 pt-8"
            >
              <div className="flex items-baseline gap-6">
                <span className="font-serif-editorial text-6xl md:text-7xl text-[#A89680] font-light leading-none">
                  {s.n}
                </span>
                <h3 className="font-serif-editorial text-3xl md:text-4xl italic text-[#1A1A1A]">
                  {s.title}
                </h3>
              </div>
              <p className="mt-6 text-[#5C564D] text-lg leading-relaxed max-w-md">
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
